import { render } from "./ChangeTime.vue?vue&type=template&id=35f42c4a"
import script from "./ChangeTime.vue?vue&type=script&lang=js"
export * from "./ChangeTime.vue?vue&type=script&lang=js"

import "./ChangeTime.vue?vue&type=style&index=0&id=35f42c4a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__